import React from 'react';

import './Spinner.css';
import ReactIconBlue from "./../../../assets/ReactBlue.png";

const Spinner = () => {
  return ( 
    <img className="ReactIcon" src={ReactIconBlue} alt="Spinning React Logo"/> 
  );
}
 
export default Spinner;